import React, { useEffect, useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import { getPackBoxesOnlyQrCodesAPI, getPackPaletsOnlyQrCodesAPI, getPackQrCodesAPI } from '../../../../api/pack/packAPI'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import MySpiner from '../../../UI/spiner/MySpiner'
import parse from 'html-react-parser';
import { Buffer } from 'buffer';

const PackQr = ({ packId, setOpen, type }) => {

    const [result, setResult] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        if (result) {
            getFile()
        }
    }, [result])

    const getQrsOnlyBoxes = () => {
        setError('')
        setLoading (true)
        getPackBoxesOnlyQrCodesAPI({ id: packId, type }).then(data => {
            setResult(data)
            setLoading (false)
        }).catch(e => {
            setError(responseError(e))
            setLoading (false)
        })
    }

    const getQrsOnlyPalets = () => {
        setError('')
        setLoading (true)
        getPackPaletsOnlyQrCodesAPI({ id: packId }).then(data => {
            setResult(data)
            setLoading (false)
        }).catch(e => {
            setError(responseError(e))
            setLoading (false)
        })
    }

    const getQrs = () => {
        setError('')
        setLoading (true)
        getPackQrCodesAPI({ id: packId, type }).then(data => {
            setResult(data)
            setLoading (false)
        }).catch(e => {
            setError(responseError(e))
            setLoading (false)
        })
    }

    const getFile = () => {
        // const buffer = Buffer.from(result);
        const buffer = Buffer.from(result.file);
        const blob = new Blob([buffer]);

        // const name = type && type === 'barcode' ? "штрих-коди на всю партію.zip" : "qr-коди на всю партію.zip"
        const name = result.fileName
                                   
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);

        setResult('')

        setOpen(false)
    }

  return (
    // <div className='packResultBlock'>
    <div>
        {/* <p className='packResultBlock__text'>QR-коди з посиланням на окремі сторінки сайту всієї партії</p> */}
        <h4>QR-коди всієї партії. Можна отримати різні QR-коди (для партії, коробок та серій)</h4>
        <br />

        {
            loading ?
                <MySpiner />
            : ''
        }

        {
			error ?
				<div className='error'>
					{ error }
				</div>
			: ''
		}
        
        <p className='packResultBlock__text'>QR-коди всіх коробок в партії:</p>

        <MyButton
            size='md'
            onClick={getQrsOnlyBoxes}
            disabled={loading ? true : false}
        >
            Отримати QR-коди
        </MyButton>

        <br />

        <p className='packResultBlock__text'>QR-коди всіх палет в партії:</p>

        <MyButton
            size='md'
            onClick={getQrsOnlyPalets}
            disabled={loading ? true : false}
        >
            Отримати QR-коди
        </MyButton>

        <br />

        <p className='packResultBlock__text'>QR-коди всієї партії (до 100 шт в партії):</p>

        <MyButton
            size='md'
            onClick={getQrs}
            disabled={loading ? true : false}
        >
            Отримати QR-коди
        </MyButton>
    </div>
  )
}

export default PackQr